import { useSelector } from "react-redux";
import { IAttach } from "../../../models/interactions/Attach";
import {
  selectSelectedElement,
  updateSelectedInteraction,
} from "../../../app/slices/TrainingSlice";
import { PiInteractionDropdown } from "./../../../components/PiInteractionDropdown";
import { useDispatch } from "react-redux";

export default function AttachmentTypeDropdown() {
  const interaction = useSelector(selectSelectedElement) as IAttach;
  const dispatch = useDispatch();

  const onChange = (playerToProp: boolean) => {
    dispatch(
      updateSelectedInteraction({ ...interaction, playerToProp } as IAttach)
    );
  };

  const getDropdownItems = () => {
    return [
      <PiInteractionDropdown.Item
        key="prop-to-player"
        onClick={() => onChange(false)}
      >
        Prop to Player
      </PiInteractionDropdown.Item>,
      <PiInteractionDropdown.Item
        key="player-to-prop"
        onClick={() => onChange(true)}
      >
        Player to Prop
      </PiInteractionDropdown.Item>,
    ];
  };

  const dropdown = (
    <PiInteractionDropdown label={"Attachment Type"}>
      <PiInteractionDropdown.Trigger>
        <div className={"flex gap-x-4 w-full"}>
          <div className={"my-auto truncate"}>
            {interaction.playerToProp ? "Player to Prop" : "Prop to Player"}
          </div>
        </div>
      </PiInteractionDropdown.Trigger>
      {getDropdownItems()}
    </PiInteractionDropdown>
  );

  return <>{dropdown}</>;
}
